export const routes = {
  base: '/',
  download: '/download-app',
  layoutSimple: '?layout=simple',
};
